module.exports = __webpack_public_path__ + "img/relax.6124fa2f.jpg";